<template>
    <div>
        <div :class="{ 'printing':printing }">
            <PageHeader className="my-favorites" heading="My Favorites" />

            <div id="favorites-header" v-show="favorites.length > 0">
                <button type="button" class="custom-btn" @click.prevent="clearFavorites()">
                    <i class="fas fa-backspace"></i> &nbsp;
                    Clear Favorites
                </button>
                <div class="my-favorites" :class="{ 'has-favorites' : favorites.length > 0 }">
                    <i class="favorites">{{ favorites.length }}</i>
                    <i class="fas fa-heart"></i>
                </div>
                <div class="print-all left-border">
                    <i class="fad fa-print"></i> Print All
                    <div class="form-check form-switch form-select-lg" @change="printSet( $event )">
                        <input class="form-check-input" type="checkbox" id="print_all" ref="print_all" checked>
                    </div>
                </div>
                <button type="button" class="custom-btn" ref="printButton" @click.prevent="printFavorites()">
                    <i class="fas fa-print"></i> &nbsp;
                    Print
                </button>
                <button type="button" class="custom-btn" @click.prevent="shareFavorites()" :disabled="isOffline">
                    <i class="fas fa-share-alt"></i> &nbsp;
                    Share
                </button>
            </div>

            <div class="container favorites-container" ref="favoritesArea" v-show="favorites.length > 0">
                <!-- floorplans -->
                <FavoritePanel title="Floorplans"
                               id="floorplans"
                               :total="floorplans.length"
                               v-if="floorplans.length > 0"
                               @printSet="printSet">
                    <FavoritePanelModelDetail v-for="rec in floorplans"
                                              :key="rec.data.modelID"
                                              :model="rec"
                                              :communityID="communityID"
                                              @removeFavorite="removeFavorite"
                                              @printSet="printSet" />
                </FavoritePanel>

                <!-- mir -->
                <FavoritePanel title="Move In Ready"
                               id="mir"
                               :total="mir.length"
                               v-if="mir.length > 0"
                               @printSet="printSet">
                    <FavoritePanelModelDetail v-for="rec in mir"
                                              :key="rec.data.modelID"
                                              :model="rec"
                                              :communityID="communityID"
                                              @removeFavorite="removeFavorite"
                                              @printSet="printSet" />
                </FavoritePanel>

                <!-- poi -->
                <FavoritePanel title="Points of Interest"
                               id="poi"
                               :total="poi.length"
                               v-if="poi.length > 0"
                               @printSet="printSet">
                    <div class="d-flex places">
                        <div v-for="place in poi" :key="place.place_id" class="place">
                            <div>
                                <h3>
                                    {{ place.name }}
                                </h3>
                                <small>
                                    {{
                                        place.address.address1 +
                                            ( place.address.address2 !== '' ? ', ' + place.address.address2 : '' )
                                    }}
                                </small>
                            </div>
                        </div>
                    </div>
                </FavoritePanel>
            </div>

            <div v-if="favorites.length === 0" class="no-results">
                <div>
                    <strong>All your favorites have been removed.</strong><br />
                    <small>Browse around and return once you save some favorites</small>
                </div>
            </div>

            <div id="printing">
                <div>
                    <i class="fal fa-spinner-third fa-spin fa-4x text-white"></i>
                </div>
            </div>
        </div>

        <div id="print-area" ref="printArea"></div>
    </div>
</template>

<script>
    import PageHeader from "@/components/PageHeader.vue";
    import FavoritePanel from "@/components/FavoritePanel.vue";
    import FavoritePanelModelDetail from "@/components/FavoritePanelModelDetail.vue";
    import Favorites from "@/plugins/Favorites.js";

    export default {
        data(){
            return {
                printing: false
            };
        },
        components: {
            PageHeader,
            FavoritePanel,
            FavoritePanelModelDetail
        },
        computed:{
            address(){
                let str = "";
                if ( this.$store.state.kiosk.map?.location?.address ){
                    str += this.$store.state.kiosk.map.location.address.address1 + " " +
                        (
                            this.$store.state.kiosk.map.location.address.address2 !== "" ?
                                this.$store.state.kiosk.map.location.address.address2 + " " :
                                ""
                        ) +
                        this.$store.state.kiosk.map.location.address.city + ", " +
                        this.$store.state.kiosk.map.location.address.stateAbb + " " +
                        this.$store.state.kiosk.map.location.address.zipCode;
                }
                return str;
            },
            homeBuyer() {
                return this.$store.state.customer?.firstName ?
                    this.$store.state.customer?.firstName + " " + this.$store.state.customer?.lastName :
                    "Valued Home Buyer";
            },
            communityName() {
                return this.$store.state.kiosk.community;
            },
            favorites() {
                return this.$store.state.favorites;
            },
            floorplans() {
                const ids = this.$store.state.favorites
                    .map( entry => parseInt( entry.modelid ) )
                    .filter( id => id !== 0 );

                return this.$store.state.kiosk.floorplans.records.filter( entry => {
                    const id = parseInt( entry.data.modelID );
                    return ids.indexOf( id ) !== -1;
                } );
            },
            isOffline(){
                return this.$store.state.isOffline;
            },
            mir() {
                const ids = this.$store.state.favorites
                    .map( entry => parseInt( entry.modelid ) )
                    .filter( id => id !== 0 );

                return this.$store.state.kiosk.inventory.records.filter( entry => {
                    const id = parseInt( entry.data.modelID );
                    return ids.indexOf( id ) !== -1;
                } );
            },
            poi() {
                const ids = this.$store.state.favorites
                    .map( entry => parseInt( entry.mapentryid ) )
                    .filter( id => id !== 0 );
                const places = [];

                this.$store.state.kiosk.map.places.forEach( category => {
                    category.places.forEach( place => {
                        if ( ids.indexOf( place.id ) !== -1 )
                            places.push( place );
                    } );
                } );
                return places;
            },
            communityID(){
                return this.$store.state.kiosk.communityID;
            },
            coverPageHeading(){
                return this.$store.state.kiosk.printLogo !== ""  ?
                    `<img src="${this.$store.state.kiosk.printLogo}" />` :
                    this.$store.state.kiosk.welcomeScreenLogo !== ""  ?
                        `<img src="${this.$store.state.kiosk.welcomeScreenLogo}" />` :
                        `<h1>${this.communityName}</h1>`;
            }
        },
        methods: {
            formatNumber( value ){
                return new Intl.NumberFormat().format( value );
            },
            removeFavorite( event ){
                const target = event.target.closest( "[data-favorite]" );
                Favorites.removeFavorite( { ...target.dataset } );
            },
            clearFavorites(){
                this.$store.dispatch( "openModal", { action:"clear-favorites", isModal: true } );
            },
            printFavorites(){
                this.printing = true;

                this.renderCoverPage();

                this.$refs.favoritesArea.querySelectorAll( ".plan" ).forEach( plan => {

                    if ( plan.querySelector( ".form-check-input" ).checked ) {
                        const _content      = plan.cloneNode( true );
                        const _floorplans   = _content.querySelector( "select" );
                        const _pages        = [ _content ];

                        // this has multiple floorplans
                        if ( _floorplans ){
                            for ( var i = 1; i < _floorplans.options.length; i++ ){
                                _pages.push( _content.cloneNode( true ) );
                            }
                            _pages.forEach( ( page, index ) => {
                                page.querySelector( ".header > h1" ).innerHTML += " : " + _floorplans.options[index].innerText;
                                page.querySelectorAll( ".floorplan-image" ).forEach( ( image, imageIndex ) => {
                                    if ( imageIndex === index )
                                        image.classList.add( "on" );
                                    else
                                        image.classList.remove( "on" );
                                } );
                            } );
                        }

                        _pages.forEach( page => {
                            const container = document.createElement( "div" );
                            container.classList.add( "print-page" );
                            container.innerHTML = `
                            <div class="page-header">
                                <img src="/svg/logos/kolterhomes-logo.svg" />
                                <h1>${this.communityName}</h1>
                            </div>
                            <div class="page-content">
                                ${page.outerHTML}
                            </div>`;
                            this.$refs.printArea.appendChild( container );
                        } );
                    }
                } );

                const poi = this.$refs.favoritesArea.querySelector( "#_poi" );

                if ( poi && poi.querySelector( ".form-check-input" ).checked ) {
                    const _content = poi.querySelector( ".places" ).cloneNode( true );
                    const _page = document.createElement( "div" );
                    _page.classList.add( "print-page" );
                    _page.innerHTML = `
                    <div class="page-header">
                        <img src="/svg/logos/kolterhomes-logo.svg" />
                        <h1>${this.communityName}</h1>
                    </div>
                    <div class="page-content">
                        <h2>Points of Interest</h2>
                        ${_content.outerHTML}
                    </div>`;
                    this.$refs.printArea.appendChild( _page );
                }


                window.onafterprint = () => {
                    this.printing = false;
                    this.$refs.printArea.innerHTML = "";
                };

                setTimeout( ()=> {
                    window.print();
                }, 250 );

            },
            renderCoverPage(){
                this.$refs.printArea.innerHTML = `<div class="print-page cover-page">
                    <div class="page-header">
                        <img src="/svg/logos/kolterhomes-logo.svg" />
                        <h1>${this.communityName}</h1>
                    </div>
                    <div class="page-footer">
                        <img src="/svg/logos/kolterhomes-logo.svg" />
                        <h1>${this.communityName}</h1>
                    </div>
                    <div class="page-content">
                        <h3 class="brochure-heading">
                            <i class="fas fa-heart"></i>
                            <span>Personalized Presentation for</span>
                            <strong>${this.homeBuyer}</strong>
                        </h3>
                        <div>
                            ${this.coverPageHeading}
                            <small>${this.address}</small>
                        </div>
                        <div>
                            Thank you for visiting ${this.communityName}<br />
                            A Kolter Homes Community
                        </div>
                    </div>
                </div>`;
            },
            shareFavorites(){
                if ( this.isOffline )
                    this.$store.dispatch( "openModal", { action:"offline" } );
                else
                    this.$store.dispatch( "openModal", { action:"share-favorites", isModal: true } );
            },
            printSet( event ){
                if ( event.target.id === "print_all" ){
                    this.$refs.favoritesArea.querySelectorAll( "[type=\"checkbox\"]" ).forEach( checkbox => {
                        checkbox.checked = event.target.checked;
                    } );
                    this.$refs.printButton.disabled = !event.target.checked;
                }
                else if ( event.target.id.indexOf( "_model_checkbox" ) !== -1 ){
                    const parent = event.target.closest( ".accordion" ),
                          checkbox = parent.querySelector( ".form-check-input" );
                    if ( !event.target.checked ){
                        this.$refs.print_all.checked = false;
                        checkbox.checked = false;
                        this.updatePrintButtonState();
                    }
                    else {
                        this.updatePrintAllCheckBox( parent.querySelector( ".accordion-body" ), checkbox );
                    }
                }
                else {
                    const parent = event.target.id.replace( "_checkbox","" );
                    this.$refs.favoritesArea.querySelectorAll( `#${parent}_body [type="checkbox"]` ).forEach( checkbox => {
                        checkbox.checked = event.target.checked;
                    } );
                    if ( !event.target.checked ){
                        this.$refs.print_all.checked = false;
                        this.updatePrintButtonState();
                    }
                    else
                        this.updatePrintAllCheckBox();
                }
            },
            updatePrintAllCheckBox( section, checkbox ){
                if ( section && checkbox ){
                    if (
                        section.querySelectorAll( "[type=\"checkbox\"]" ).length ===
                        section.querySelectorAll( "[type=\"checkbox\"]:checked" ).length
                    ){
                        checkbox.checked = true;
                        this.updatePrintAllCheckBox();
                    }
                }
                else {
                    const all = this.$refs.favoritesArea.querySelectorAll( "[type=\"checkbox\"]" ).length,
                          checked = this.$refs.favoritesArea.querySelectorAll( "[type=\"checkbox\"]:checked" ).length;
                    if ( all === checked )
                        this.$refs.print_all.checked = true;
                }
                this.$refs.printButton.disabled = false;
            },
            updatePrintButtonState(){
                const totalChecked = this.$refs.favoritesArea.querySelectorAll( "[type=\"checkbox\"]:checked" ).length;
                this.$refs.printButton.disabled = !totalChecked;
            }
        }
    };
</script>
